import extractDefinitions from "../extractDefinitions";
import toArray from "../utils/toArray";
// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Table = ({ children, headerRows, widths, ...rest }) => {
    return {
        table: {
            headerRows,
            widths,
            body: toArray(extractDefinitions(children))
        },
        ...rest
    };
};
// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Table.Row = ({ children }) => toArray(extractDefinitions(children));
export default Table;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9UYWJsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxrQkFBa0IsTUFBTSx1QkFBdUIsQ0FBQztBQUV2RCxPQUFPLE9BQU8sTUFBTSxrQkFBa0IsQ0FBQztBQVV2QyxnRkFBZ0Y7QUFDaEYsOERBQThEO0FBQzlELE1BQU0sS0FBSyxHQUFHLENBQUMsRUFBRSxRQUFRLEVBQUUsVUFBVSxFQUFFLE1BQU0sRUFBRSxHQUFHLElBQUksRUFBYyxFQUFPLEVBQUU7SUFDM0UsT0FBTztRQUNMLEtBQUssRUFBRTtZQUNMLFVBQVU7WUFDVixNQUFNO1lBQ04sSUFBSSxFQUFFLE9BQU8sQ0FBQyxrQkFBa0IsQ0FBQyxRQUFRLENBQUMsQ0FBQztTQUM1QztRQUNELEdBQUcsSUFBSTtLQUNSLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixnRkFBZ0Y7QUFDaEYsOERBQThEO0FBQzlELEtBQUssQ0FBQyxHQUFHLEdBQUcsQ0FBQyxFQUFFLFFBQVEsRUFBaUMsRUFBTyxFQUFFLENBQy9ELE9BQU8sQ0FBQyxrQkFBa0IsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO0FBRXhDLGVBQWUsS0FBSyxDQUFDIn0=